import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-payment-tile__labels"
}
const _hoisted_2 = { class: "_flex _ai-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_label = _resolveComponent("base-label")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.classes),
    "data-qa": "payment-tile"
  }, [
    ($options.hasLabels)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.labels, (label) => {
            return (_openBlock(), _createBlock(_component_base_label, {
              key: label.label,
              theme: label.theme,
              "data-qa": "payment-tile-label"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(label.label), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: "_cur-p _pa-3 _flexcol _gap-3",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onClick && $options.onClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_checkbox_field, {
          "model-value": $props.isSelected,
          "show-label": false,
          name: "paymentTile",
          class: "_mt-0 _mr-2",
          "checked-value": true,
          type: "radio"
        }, null, 8 /* PROPS */, ["model-value"]),
        _createTextVNode(" " + _toDisplayString($props.name) + " ", 1 /* TEXT */),
        ($props.imageUrl)
          ? (_openBlock(), _createBlock(_component_base_image, {
              key: 0,
              src: $props.imageUrl,
              alt: $props.name,
              width: "34",
              class: "_ml-a",
              "data-qa": "payment-method-image"
            }, null, 8 /* PROPS */, ["src", "alt"]))
          : ($props.iconName)
            ? (_openBlock(), _createBlock(_component_base_icon, {
                key: 1,
                name: $props.iconName,
                class: "_ml-a _tc--accent",
                size: "lg",
                "data-qa": "payment-method-image"
              }, null, 8 /* PROPS */, ["name"]))
            : _createCommentVNode("v-if", true)
      ]),
      ($props.isSelected)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}